import React, { Component } from 'react'
// import { initStore } from '../store'
// import { bindActionCreators } from 'redux';
// import withRedux from 'next-redux-wrapper';
import { connect } from 'react-redux';
// import { compose } from 'recompose';
import PropTypes from 'prop-types';

import AppCustomLink from '../../components/Common/AppCustomLink';
// import Link from 'next/link';
import { cdnApi, podcastTypes, firestoreApi, mergedAdPodcasts, storageUrl, showTagName } from '../../lib/utils';
import { getBrowsePageTab, getForYouAdGenre, getRecommendedEpisodes, setBrowsePageTab } from '../../lib/fileUtils';
import { fetchTopChartsPodcasts, fetchTopChartsEpisodes, fetchAds, getBrowsePlaylists } from '../../actions';
// import { fetchUserSubscriptions } from '../actions/PodcastActions';

import InfiniteScroll from 'react-infinite-scroll-component';

// import CommonLayout from '../components/CommonLayout';
import Podcast from '../../components/Podcast/Podcast';
import PodcastEpisode from '../../components/Podcast/PodcastEpisode';
import { DownOutlined, TagOutlined } from '@ant-design/icons';
// import BrowseCategory from '../components/BrowseCategory';

import { Affix, Button, Col, Dropdown, Menu, Radio, Row, Tabs } from 'antd';
const { TabPane } = Tabs;
import { spacing, colors, fontSize, topBar, mainLayoutColor, maxScreenSize, minScreenSize } from '../../lib/theme';
// import FireStoreParser from 'firestore-parser';
// import Router from 'next/router';
import { logBrowseTabGenre } from '../../lib/analyticsEvents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PodcastTile from '../Podcast/PodcastTile';
import { bindActionCreators } from 'redux';
import { FOR_YOU_OTHER } from '../../lib/strings';
import ProBadge from './ProBadge';
import slugify from 'slugify';
import LoadingSpinner from './Loading';


class TopCharts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasMorePodcasts: true, hasMoreEpisodes: true, podcastsArray: props.podcastsArray,
            episodesArray: props.episodesArray, boxShadow: '', forceRenderEpisodes: true,
            displayType: 'podcasts', playlistsArray: []
        };
    }

    componentDidMount() {
        const { podcastTypeId, tabType } = this.props;
        console.dir(podcastTypeId);
        console.dir(tabType);
        if (podcastTypeId != 'All') {
            this.props.fetchAds(podcastTypeId);
        }
        this.loadPlaylists();
        if (tabType == 'playlists') {
            setBrowsePageTab('playlists');
        }
        // setTimeout(() => {
        //   this.setState({forceRenderEpisodes: true});
        //   console.dir('forceRenderEpisodes');
        // }, 1000);
    }

    componentDidUpdate(prevProps) {
        const { tabType } = this.props;
        console.dir(tabType);
        if (tabType !== prevProps.tabType && tabType == 'playlists') {
            setBrowsePageTab('playlists');
            this.loadPlaylists();
            // this.setState({});
        }
    }

    cleanPodcastTypeId(podcastTypeId) {
        return podcastTypeId.replace('-and-', ' & ').replace(',', ' & ');
    }

    changeGenre = (podcastTypeId) => {
        console.dir(podcastTypeId);
    }

    setActiveTab = (activeTab) => {
        // setBrowsePageTab(activeTab);
    }

    fetchNextPodcastsData = async () => {
        const { podcastTypeId } = this.props;
        const { podcastsArray } = this.state;
        if (podcastTypeId == 'for-you') {
            this.setState({ hasMorePodcasts: false });
            return;
        }
        let nextTopPodcasts = await fetchTopChartsPodcasts(podcastTypeId, 2);
        // console.dir(nextTopPodcasts);
        this.setState({ podcastsArray: [...podcastsArray, ...nextTopPodcasts], hasMorePodcasts: false });
    }

    fetchNextEpisodesData = async () => {
        const { podcastTypeId } = this.props;
        const { episodesArray } = this.state;
        if (podcastTypeId == 'for-you') {
            this.setState({ hasMorePodcasts: false });
            return;
        }
        let nextTopEpisodes = await fetchTopChartsEpisodes(podcastTypeId, 2);
        // console.dir(nextTopEpisodes);
        this.setState({ episodesArray: [...episodesArray, ...nextTopEpisodes], hasMoreEpisodes: false });
    }

    changeAffixShadow = (affixed) => {
        // console.dir(affixed);
        if (affixed) {
            this.setState({ boxShadow: 'box-shadow' });
        } else {
            this.setState({ boxShadow: '' });
        }
    }

    onDisplayTypeChange = async (e) => {
        setBrowsePageTab(e.target.value);
        this.setState({
            displayType: e.target.value
        });
        if (e.target.value == 'playlists') {
            this.loadPlaylists();
        }
    }
    loadPlaylists = async () => {
        const playlistsArray = await getBrowsePlaylists();
        console.dir(playlistsArray);
        this.setState({ playlistsArray });
    }

    render() {
        const { podcastTypeId, settingsState, adPodcasts, homePodcastsMain, tabType } = this.props;
        const { podcastsArray, episodesArray, playlistsArray, hasMorePodcasts, hasMoreEpisodes, boxShadow, forceRenderEpisodes, displayType } = this.state;
        // console.dir(podcastsInfo);
        // console.dir(podcastsArray);
        const adGenreId = podcastTypeId == 'All' ? FOR_YOU_OTHER : podcastTypeId;
        const adPodcastsSpecific = adPodcasts[adGenreId] || [];
        console.dir(mergedAdPodcasts(podcastsArray, adPodcastsSpecific));

        console.dir(getBrowsePageTab());
        let currentBrowsePageTab = getBrowsePageTab();
        if (!currentBrowsePageTab && tabType == 'playlists') {
            currentBrowsePageTab = 'playlists';
        }
        if (!currentBrowsePageTab) {
            currentBrowsePageTab = 'podcasts';
        }
        console.dir(currentBrowsePageTab);

        let podcastsFinArray = podcastsArray;
        let episodesFinArray = episodesArray;
        if (podcastTypeId == 'for-you') {
            const pods = homePodcastsMain['Recommended For You'] || [];
            console.dir(pods);
            podcastsFinArray = pods;
            episodesFinArray = getRecommendedEpisodes();
            console.dir(episodesFinArray);
        }

        // const menu = (
        //     <Menu className='browse-pagination'>
        //         {podcastTypes.map((podcastType) => (
        //             <Menu.Item key={podcastType.id} onClick={this.changeGenre.bind(this, podcastType.id)}>
        //                 {podcastType.id == 'All' ?
        //                     <AppCustomLink href={`/top-charts`}>
        //                         <a className=''>
        //                             <p style={{ marginBottom: '0' }}><FontAwesomeIcon style={{ fontSize: '1.25em', marginRight: '12px' }} icon='podcast' />
        //                                 {podcastType.name}</p></a>
        //                     </AppCustomLink>
        //                     : <AppCustomLink href={`/top-charts/[id]`} as={`/top-charts/${podcastType.id}`}>
        //                         <a className='' style={{ color: podcastType['color'] }}>
        //                             <FontAwesomeIcon style={{ fontSize: '1.25em', marginRight: '12px' }} icon={podcastType['icon']} />
        //                             {podcastType.name}</a>
        //                     </AppCustomLink>}
        //             </Menu.Item>
        //         ))}
        //     </Menu>
        // );

        // const currentPodcastType = podcastTypes.find((el) => el.id == podcastTypeId) || { 'name': '' };

        return (
            <div>
                {/* <Nav /> */}
                <Affix offsetTop={settingsState.topBar} onChange={this.changeAffixShadow}>
                    <div className={boxShadow}>
                        <Row>
                            <Col span={24}>
                                {/* <AppCustomLink href={`/browse`}><a> */}
                                {/* <h1 style={{ 'display': 'inline-block', 'marginBottom': '1em', fontSize: `${fontSize('lg')}` }}>
                                    Trending
                                </h1> */}
                                <div style={{ textAlign: 'center' }}>
                                    <Radio.Group onChange={this.onDisplayTypeChange}
                                        value={currentBrowsePageTab} buttonStyle="solid">
                                        <Radio.Button value="podcasts">
                                            <div className='main-tab'>Shows</div></Radio.Button>
                                        <Radio.Button value="episodes">
                                            <div className='main-tab'>Episodes</div></Radio.Button>
                                        <Radio.Button value="playlists">
                                            <div className='main-tab'>Playlists</div></Radio.Button>
                                    </Radio.Group>
                                </div>
                                {/* this is just for seo, don't delete */}
                                {/* <div style={{
                                    display: 'flex', height: '1px', position: 'absolute',
                                    top: '-360px'
                                }}>
                                    {podcastTypes.map((podcastType) => (
                                        <div key={podcastType.id}>
                                            {podcastType.id == 'All' ? <AppCustomLink href={`/top-charts`}>
                                                <a style={{ fontSize: '1px' }} className=''>{podcastType.name}</a></AppCustomLink>
                                                : <AppCustomLink href={`/top-charts/[id]`} as={`/top-charts/${podcastType.id}`}>
                                                    <a style={{ fontSize: '1px' }} className=''>{podcastType.name}</a>
                                                </AppCustomLink>}
                                        </div>
                                    ))}
                                </div> */}
                            </Col>
                            {/* <Col span={12} style={{ textAlign: 'right' }}>
                                <Dropdown overlay={menu} trigger={['click']} placement="bottomCenter">
                                    <Button className='genre-dropdown' style={{}}>
                                        {currentPodcastType.name} &nbsp;<DownOutlined />
                                    </Button>
                                </Dropdown>
                            </Col> */}
                        </Row>
                    </div>
                </Affix>
                <br />

                <Tabs className='top-charts' defaultActiveKey={currentBrowsePageTab == 'playlists' ? 'All' : podcastTypeId}
                    activeKey={currentBrowsePageTab == 'playlists' ? 'All' : podcastTypeId} onChange={this.setActiveTab}
                    animated={false}>
                    {(currentBrowsePageTab == 'playlists' ? [{ 'id': 'All', 'name': 'All' }] : [{
                        'id': 'for-you',
                        'name': 'For You'
                    }, ...podcastTypes]).map((podcastType) => (
                        <TabPane tab={<AppCustomLink href={`/top-charts/${podcastType.id}`} >
                            <a style={{}} className=''>
                                <p className='serif mb-0'>
                                    {podcastType.name} {displayType == 'podcasts' && podcastType.id == 'for-you' && <span><ProBadge marginTop={1} /></span>}
                                </p></a>
                        </AppCustomLink>} key={podcastType.id}>
                            <br />
                            {currentBrowsePageTab == 'podcasts' && podcastsFinArray.length < 1 && <div className='text-center mt-2'><h4>Your podcast recommendations will show up here.</h4></div>}
                            {currentBrowsePageTab == 'podcasts' &&
                                <InfiniteScroll
                                    dataLength={Math.floor(podcastsFinArray.length)} //This is important field to render the next data
                                    next={this.fetchNextPodcastsData}
                                    hasMore={hasMorePodcasts}
                                    scrollThreshold={0.75}
                                    loader={<div></div>}>
                                    <div className='flex'>
                                        {podcastsFinArray && mergedAdPodcasts(podcastsFinArray, adPodcastsSpecific).map((podcast, index) =>
                                            <div className='podcast-tile' key={podcast.id + `${index}`} style={{ marginRight: `${spacing()}` }}>
                                                <div className='podcast-card'>
                                                    <Podcast podcast={podcast} size='lg' showSubscribe={true} showArtistName={true} />
                                                </div>
                                                <div className='podcast-tile-child'>
                                                    <PodcastTile
                                                        adGenreId={podcastTypeId == 'All' ? getForYouAdGenre() : podcastTypeId}
                                                        parentAd={'Trending-' + podcastTypeId}
                                                        podcast={podcast} size='lg' showSubscribe={true} showArtistName={true} showSeparator={true} />
                                                </div>
                                            </div>
                                        )
                                        }
                                    </div>
                                </InfiniteScroll>
                            }
                            {currentBrowsePageTab == 'episodes' &&
                                <InfiniteScroll
                                    dataLength={Math.floor(episodesFinArray.length)} //This is important field to render the next data
                                    next={this.fetchNextEpisodesData}
                                    hasMore={hasMoreEpisodes}
                                    scrollThreshold={0.75}
                                    loader={<div></div>}>
                                    {episodesFinArray && episodesFinArray.map((episode, index) =>
                                        <PodcastEpisode key={index} podcastEpisode={episode} parent='' showSeparator={true} />
                                    )
                                    }
                                </InfiniteScroll>
                            }
                            {currentBrowsePageTab == 'playlists' &&
                                <div>
                                    {playlistsArray.length < 1 && <LoadingSpinner />}
                                    {playlistsArray.sort((el1, el2) => el2.rating - el1.rating).map((playlist, index) => (
                                        playlist['type'] == 'tag'
                                            ?
                                            <AppCustomLink key={index} as={`/tags/${playlist.userUID}_${playlist.tagId}`} href={`/tags/${playlist.userUID}_${playlist.tagId}`}>
                                                <div className='playlist-tile'>
                                                    <div>
                                                        {playlist['imageName'] ?
                                                            <img style={{ width: '80px' }} src={`${storageUrl}playlists/${playlist['imageName']}`} />
                                                            :
                                                            <div style={{ width: '80px', background: '#4E7CFF', height: '80px', textAlign: 'center' }}>
                                                                <TagOutlined style={{ fontSize: '30px', color: 'white', marginTop: '24px' }} />
                                                            </div>
                                                        }
                                                    </div>
                                                    <div style={{ marginLeft: '1em' }}>
                                                        <h4>{showTagName(playlist.name)}</h4>
                                                        <h5>{playlist['tag'] && Object.keys(playlist['tag']).length || 0} Podcasts</h5>
                                                    </div>
                                                </div>
                                            </AppCustomLink> :
                                            <AppCustomLink key={index} as={`/playlist/${slugify(playlist.name)}-i${playlist.playlistId}`} href={`/playlist?id=${playlist.playlistId}`}>
                                                <div className='playlist-tile'>
                                                    <div>
                                                        <img style={{ width: '80px' }} src={`${storageUrl}playlists/${playlist['imageName']}`} />
                                                    </div>
                                                    <div style={{ marginLeft: '1em' }}>
                                                        <h4>{playlist.name}</h4>
                                                        <h5>{playlist['guidEpisodeArray'] && playlist['guidEpisodeArray'].length || 0} Episodes</h5>
                                                    </div>
                                                </div>
                                            </AppCustomLink>
                                    ))}
                                </div>}
                        </TabPane>
                    ))}
                    {/* <TabPane forceRender={forceRenderEpisodes} tab="Episodes" key="1">
                        <InfiniteScroll
                            dataLength={Math.floor(episodesArray.length)} //This is important field to render the next data
                            next={this.fetchNextEpisodesData}
                            hasMore={hasMoreEpisodes}
                            scrollThreshold={0.75}
                            loader={<div></div>}>
                            {episodesArray && episodesArray.map((episode, index) =>
                                <PodcastEpisode key={index} podcastEpisode={episode} parent='' showSeparator={true} />
                            )
                            }
                        </InfiniteScroll>
                    </TabPane> */}
                </Tabs>

                {/* </Row> */}
                {/* <p>And many more.  */}
                {
                    currentBrowsePageTab != 'playlists' && <div style={{ marginTop: `${spacing('lg')}`, textAlign: 'center' }}>
                        {/* <p>Also <AppCustomLink href={`/search`}><a className='search-btn'>Search</a></AppCustomLink> for your favourite podcast.</p> */}
                        <AppCustomLink href={`/search`}><Button className='search-full-btn'>Search for more</Button></AppCustomLink>
                    </div>
                }
                <style jsx>
                    {`
                    .playlist-tile {
                        display: flex;
                        margin-bottom: 2em;
                        cursor: pointer;
                    }
              :global(.genre-dropdown) {
                min-width: 320px; 
                transform: translate(0,-4px); 
                z-index: 10; 
                width: 45%; 
                color: ${colors.primary}; 
                border: 1px solid ${colors.primary};
              }
              :global(.top-charts .ant-tabs-nav-scroll) {
                white-space: normal;
                text-align: center;
              }
              :global(.top-charts .ant-tabs-ink-bar) {
                display: none !important;
              }
              :global(.top-charts .ant-tabs-nav .ant-tabs-nav-list) {
                    flex-direction: row;
                    flex-wrap: wrap;
                    justify-content: center;
              }
              :global(.top-charts .ant-tabs-nav .ant-tabs-tab-active) {
                  border-bottom: 2px solid ${colors.primary};
              }
              :global(.top-charts .ant-tabs-nav .ant-tabs-tab-active p) {
                color: ${colors.primary};
              }
              :global(.top-charts .ant-tabs-nav .ant-tabs-tab) {
                padding: 4px 0;
                margin-right: 0px;
                margin-left: 24px;
              }
              .flex {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
              }
              :global(.box-shadow) {
                padding: 0 1em;
                padding-top: 1.5em;
                background: ${settingsState.mainLayoutColor};
                box-shadow: 0 4px 4px -2px rgba(0,0,0,.2);
              }
              :global(.search-btn){
                // background: ${colors.third};
                // border: ${colors.third};
                color: ${colors.third} !important;
                text-decoration: underline;
              }
              :global(.search-full-btn){
                background: ${colors.third};
                color: white; // ${colors.third} !important;
                height: ${spacing('xl')};
                border-radius: ${spacing('lg')};
                border: none;
                width: 12em;
              }
              :global(.browse-pagination) {
                max-width: 680px;// 50vw;
                flex-flow: row wrap;
                display: flex;
                justify-content: center; // flex-start;
              }
              :global(.browse-pagination li) {
                  // flex-grow: 1;
                  // flex-shrink: 0;
                  // flex-basis: 10%;
                  width: 188px;
                  // text-align: right;
                  border: 1px solid ${colors.primaryDim};
                  margin-left: ${spacing()};
                  margin-right: ${spacing()};
                  border-radius: ${spacing()};
                  margin-top: ${spacing('xs')};
                  margin-bottom: ${spacing('xs')};
              }
              :global(.browse-pagination li:hover) {
                  background-color: ${colors.primaryDim};
              }
              .main-tab {
                  width: 100px;
              }
              @media ${minScreenSize.tablet} {
                .podcast-card {
                    display: none !important;
                }
                .podcast-tile {
                  width: 100%;
                }
              }
              @media ${maxScreenSize.tablet} {
                :global(.genre-dropdown) {
                  min-width: 160px; 
                  width: auto;
                }
                .podcast-tile-child {
                    display: none;
                }
              }
            `}
                </style>
            </div >
        );
    }
}

TopCharts.propTypes = {
    podcastsArray: PropTypes.array,
    episodesArray: PropTypes.array,
    podcastTypeId: PropTypes.string,
    tabType: PropTypes.string,
    settingsState: PropTypes.object,
    adPodcasts: PropTypes.object,
    fetchAds: PropTypes.func,
    homePodcastsMain: PropTypes.object,
}

const mapStateToProps = (state) => {
    return {
        settingsState: state.settingsState,
        adPodcasts: state.adPodcasts,
        homePodcastsMain: state.homePodcastsMain,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchAds: bindActionCreators(fetchAds, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TopCharts);
